import * as React from "react";
import { twMerge } from "tailwind-merge";

interface InputProps {
  id: string;
  name: string;
  label: string;
  autoComplete: string;
  error: {
    inError: boolean;
    message?: string;
  };
  value: string;
  onChange: (name: string, e: React.ChangeEvent<HTMLInputElement>) => void;
}

const InputText = ({
  id,
  name,
  label,
  autoComplete,
  error,
  onChange,
  value,
}: InputProps) => {
  const [state, setState] = React.useState<"default" | "focused" | "filled">(
    "default"
  );
  React.useEffect(() => handleBlur(), [value]);

  const [hover, setHover] = React.useState<boolean>(false);

  const handleBlur = () => setState(value.length > 1 ? "filled" : "default");

  return (
    <div
      className={"relative flex flex-col mt-12 "}
      onFocus={() => setState("focused")}
      onBlur={handleBlur}
    >
      <label
        htmlFor={id}
        className={twMerge(
          "absolute",
          hover ? "text-primaryD2" : "text-primary",
          state == "default"
            ? "bottom-0 lg:text-xl text-lg"
            : "bottom-8 lg:text-sm text-xs",
          error.inError && "text-secondary text-sm lg:text-xs bottom-8"
        )}
      >
        {error.inError && error.message ? `Erreur : ${error.message}` : label}
      </label>
      <input
        id={id}
        type="text"
        name={name}
        onChange={(e) => onChange(name, e)}
        value={value}
        autoComplete={autoComplete}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        className={twMerge(
          "border-white border-b-primary border-b-2 w-full sm:w-60 py-1 px-0",
          "hover:border-b-primaryD2 focus:ring-0 focus:border-white focus:border-b-primary"
        )}
      />
    </div>
  );
};

export default InputText;
